export { StarsIcon } from './stars'
